import { render, staticRenderFns } from "./ProfileCollection.posts.vue?vue&type=template&id=9f858c4a&scoped=true&"
import script from "./ProfileCollection.posts.vue?vue&type=script&lang=js&"
export * from "./ProfileCollection.posts.vue?vue&type=script&lang=js&"
import style0 from "./ProfileCollection.posts.vue?vue&type=style&index=0&id=9f858c4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f858c4a",
  null
  
)

export default component.exports